// // This file can be replaced during build by using the `fileReplacements` array.
// // `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// // The list of file replacements can be found in `angular.json`.

// // export const environment = {
// //   production: false,
// //   SERVER_URL: "http://185.85.241.86:7003/api/",
// //   login_url: "http://185.85.241.86:7003/api/"
// // };
// export const environment = {
//   production: false,
//   // SERVER_URL: "http://icanrefer.jobraiser.com/api/",
//   // SERVER_URL: "https://www.tallite.com/api_v2/",
//   SERVER_URL: "https://www.tallite.com/api_uat/",
//   VIEWER_URL: "https://www.tallite.com/api_uat/",
//   ATTACHMENT_URL: "https://www.tallite.com/api_uat/icrweb/",
//   // SHORTCODE: '',
//   // SHORTCODE: 'PSS', //Grabagrub
//   SHORTCODE: 'MPG', //Grabagrub
//   login_url: "https://ats.tallint.com/career/api/api/",
//   RECAPCHA_KEY: "6LdtLs8UAAAAALT-klqix009Pk6v5ZTfxEKGhb67",
//   module_code: 1,
//   FLAGS: {
//     enable_relevant_jobs: false,
//     enable_jobs: true
//   },
//   firebase: {
//     apiKey: "AIzaSyDchHe7kUZKqjI1CFWlqMhrfq38-Q3IaNU",
//     authDomain: "tallite.firebaseapp.com",
//     projectId: "tallite",
//     storageBucket: "tallite.appspot.com",
//     messagingSenderId: "240484062323",
//     appId: "1:240484062323:web:5635e849d117bf196b0606",
//     measurementId: "G-V8DQJT9N9T",
//     vapidKey: "BKjObivodHWfNZ7fJ87kcb4giNTAaB667IE-BKuFAvL0Nh1Uc3vkemPZQnlkx0_t7HTyPaNY-hrFi8ZXfJ_ONZA"
//   }
// };


// // export const environment = {
// //   production: false,
// //   SERVER_URL: "https://er-employee.tallint.com/app/api/",
// //   login_url: "https://er-employee.tallint.com/app/api/"
// // };


// /*
//  * For easier debugging in development mode, you can import the following file
//  * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
//  *
//  * This import should be commented out in production mode because it will have a negative impact
//  * on performance if an error is thrown.
//  */
// // import 'zone.js/dist/zone-error';  // Included with Angular CLI.


// production build

export const environment = {
  production: true,
  SERVER_URL: "https://ats.manpoweronline.in/api/",
  // SERVER_URL: "https://atsuat.manpoweronline.in/api/",
  VIEWER_URL: "https://ats.manpoweronline.in/api/",
  // VIEWER_URL: "https://atsuat.manpoweronline.in/api/",
  ATTACHMENT_URL: "https://ats.manpoweronline.in/api/icrweb/",
  // ATTACHMENT_URL: "https://atsuat.manpoweronline.in/api/icrweb/",
  // SHORTCODE: '',
  // SHORTCODE: 'PSS', //Grabagrub
  SHORTCODE: 'MPG', //Grabagrub
  login_url: "https://ats.manpoweronline.in/api/api/",
  // login_url: "https://atsuat.manpoweronline.in/api/api/",
  RECAPCHA_KEY: "6LdtLs8UAAAAALT-klqix009Pk6v5ZTfxEKGhb67",
  module_code: 1,
  FLAGS: {
    enable_relevant_jobs: false,
    enable_jobs: true
  },
  firebase: {
    apiKey: "AIzaSyDchHe7kUZKqjI1CFWlqMhrfq38-Q3IaNU",
    authDomain: "tallite.firebaseapp.com",
    projectId: "tallite",
    storageBucket: "tallite.appspot.com",
    messagingSenderId: "240484062323",
    appId: "1:240484062323:web:5635e849d117bf196b0606",
    measurementId: "G-V8DQJT9N9T",
    vapidKey: "BKjObivodHWfNZ7fJ87kcb4giNTAaB667IE-BKuFAvL0Nh1Uc3vkemPZQnlkx0_t7HTyPaNY-hrFi8ZXfJ_ONZA"
  }
};